
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"25","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('linearGradient',{attrs:{"x1":"94.6%","y1":"18.931%","x2":"2.786%","y2":"47.691%","id":"a"}},[_c('stop',{attrs:{"stop-color":"#FEEEB3","offset":"0%"}}),_c('stop',{attrs:{"stop-color":"#B0884B","offset":"100%"}})])]),_c('path',{attrs:{"d":"M124.957 46.944H138v-1.14h-13.043v1.14zM117.66 43v2.803H113v1.141h4.659v2.708h4.5V43h-4.5zm1.087 3.944V44.14h2.327v4.372h-2.327v-1.568zm15.896 9.122H138v-1.14h-3.358v1.14zm-7.51-4.05v2.91H113v1.14h14.131v2.924h4.47v-6.975h-4.47zm1.086 4.05v-2.91h2.297v4.694h-2.297v-1.784zm-3.26 9.122H138v-1.14h-13.043v1.14zm-7.299-3.823v2.682H113v1.14h4.659V68h4.5v-6.635h-4.5zm1.087 3.823v-2.683h2.327v4.355h-2.327v-1.672z","transform":"translate(-113 -43)","fill":"url(#a)","fill-rule":"evenodd"}})])
          )
        }
      }
    